<div class="step--container">
  <ng-container *ngFor="let step of steps; let i = index; let last = last; let first = first">
    <div
      class="step--item"
      [class.current]="currentStepIndex - 1 === i"
      [class.completed]="currentStepIndex - 1 > i"
      [class.last]="last"
      [class.first]="first"
    ></div>
  </ng-container>
</div>
